import { commentsData } from '@/mocks/comicData';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {commentsData.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-heading font-semibold text-foreground-900 whitespace-nowrap">
                      {item.name}
                    </h3>
                    <span className="text-[11px] text-foreground-400 whitespace-nowrap">
                      {item.time}
                    </span>
                  </div>
                  <span className="inline-block text-[11px] text-accent-600 bg-accent-50 px-2 py-0.5 rounded mt-1">
                    正在追 {item.comic}
                  </span>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}